export default __webpack_public_path__ + "static/media/retour-modal.a3823ca2.svg";